import { useTheme } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const {
    submitButton: { backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: {
      position: 'relative',
    },
    actions: {
      position: 'absolute',
      display: 'flex',
      gap: 0.5,
      top: 16,
      left: 16,
      zIndex: 10,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 8,
        left: 8,
      },
    },
    transformActions: {
      position: 'absolute',
      bottom: 8,
      left: 8,
      right: 8,
      zIndex: 10,
      display: 'flex',
      gap: 1,
    },

    button: (isActive = false) => ({
      color: colors.white,
      fontSize: 14,
      px: 2,
      py: 1,
      background: isActive ? appTheme.mainColor : '#0C0B0B99',
      backdropFilter: isActive ? 'unset' : 'blur(40px)',
      borderRadius: '99px',
      lineHeight: 1.35,
      textTransform: 'none',
      display: 'flex',
      gap: 1,

      '&:hover': {
        background: appTheme.mainColor,
      },

      '& svg': {
        fontSize: 16,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 10,
        px: 1,
        py: 0.5,
        fontWeight: 500,
      },
      ...(isMobileOnly
        ? { fontSize: 10, px: 1, py: 0.5, fontWeight: 500 }
        : {}),
    }),
    imageBox: {
      '& img': {
        width: '100%',
        height: 'auto',
        display: 'flex',
        borderRadius: isMobileOnly ? 0 : 4,
        overflow: 'hidden',
      },
    },
  };
};
